module.exports = __webpack_public_path__ + "static/media/zemi.5139849d.png";